import Main from '../../main';
import * as marietta from "../../marietta";
import { BUILDING_TYPE_MANSION, ITEM_MODE_NO } from '../../marietta/webcad/Constants';
import { BuildingDocument } from "../LiDAR/commands";
import { LoadJSON } from "../LiDAR/commands/LoadJSON";
import { ZipDeCompression } from '../graphicLibs/compress/zipDecompression';
import { Convert } from '../LiDAR/jsonParse';
import { ThreeView } from "../view3d/webcad";
import { Mode3DTool } from '../view3d/webcad/util/Mode3DTool';
import { optRecognizeMode } from '../view3d/webcad/util/Option3DInterface';
import { Mark } from '../webcad/item';
import { WizardManager } from "../webcad/view/dialog";
import { LiDARAPI } from "./LiDARAPI";
import { LiDARUnitBath } from "./LiDARUnitBath";
import { WebViewData } from "./WebViewData";

export class LiDARData {

      public async json() {
        console.log("Server Access Test -\n");

        marietta.WebCADGlobal.showBusy('LiDARデーター取得中...');

        const lidarJson = new LiDARAPI(marietta.WebCADGlobal.webcad2Dmanager.LiDAR_plan_id);
        lidarJson.get().then(async (object) => {
            const json = object.lidar_data;
            console.log(json);

            marietta.WebCADGlobal.hideBusy();

            await this.load(json);
        }).catch((str) => {
            marietta.WebCADGlobal.hideBusy();

            console.log(str);
            marietta.webcad.WebCADGlobal.showAlert(`LiDARデーターの取得に失敗しました。`);

            Main.setBuildingStyleFromQueryParameterCondition();
        });
    }

  /**
   * スキャナーアプリの zip（<区画名>_<UUID>/plan.json と写真）から読み込む。写真は使わない
   * 「LiDARデーターを読み込みますか」で読み込みを押したときと同じ流れにする（デバッグメニュー用）
   */
  public async fromZip(file: File): Promise<void> {
    const JSON_EXTENSION: string = '.json';
    // API が zip の json を lidar_data に保存するときと同じく、スペース・全角スペース・改行・タブを消す
    const API_REMOVED_CHARS: RegExp = /[ 　\r\n\t]/g;
    const ERROR_MESSAGE: string = 'LiDARデーターの読み込みに失敗しました。';
    const NO_JSON_MESSAGE: string = `zip に ${JSON_EXTENSION} がありません`;

    marietta.webcad.WebCADGlobal.itemMenu.initView();
    ThreeView.get().buildingDocument = new BuildingDocument();
    try {
      await ThreeView.get().buildingDocument.execute();
    } catch (error) {
      // 物件ドキュメントを取れない環境（ローカルなど）でも読み込む。ピンの写真のリンクが付かないだけ
      console.warn(error);
    }

    try {
      const files: File[] = await new ZipDeCompression(file).decompress();
      const planFile: File | undefined = files.find((entry: File) => entry.name.endsWith(JSON_EXTENSION));
      if (!planFile) {
        throw new Error(NO_JSON_MESSAGE);
      }
      const json: string = (await planFile.text()).replace(API_REMOVED_CHARS, '');
      await this.load(json);
    } catch (error) {
      marietta.WebCADGlobal.hideBusy();
      console.log(error);
      marietta.webcad.WebCADGlobal.showAlert(ERROR_MESSAGE);
    }
  }

  /**
   * LiDARデーター（API の lidar_data と同じ形の JSON 文字列）を読み込み、部屋指定ウィザードまで進める
   */
  private async load(json: string): Promise<void> {
            const webcadData = JSON.parse(json);
            if (webcadData.application.customize && webcadData.application.customize === 'LiDARAPP') { // WebView
              await this.readWebView(webcadData);
              return;
            }

            const JSONParse = Convert.toJSONParse(json);
            // サーバーから取得したLiDARデーターより
            // const lidarData = JSON.parse(json);

            // UB の高さを初期値に
            LiDARUnitBath.applyToRawData(JSONParse);
            ThreeView.get().LidarManager = new LoadJSON(JSONParse);
            ThreeView.get().LidarManager.execute();

            ThreeView.get().wizardManager = new WizardManager();

            marietta.WebCADGlobal.showBusy('補正中...');

            /** 自動補正（現状 2023/2/2 の流れは、外周から傾き補正 → 短い壁の削除 → モジュールピッチ補正） */
            ThreeView.get().LidarManager.autoCorrection();
            // UB の高さを部屋の天井高さに（補正で描き直すと初期値に戻るため、補正のあと）
            LiDARUnitBath.fitToCeiling();
            marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();

            marietta.WebCADGlobal.hideBusy();

            /** ウィザード開始 */
            ThreeView.get().selectWizard();

            // const object = JSON.parse(jsonstr);
            // if (object == null) {
            //     return Promise.reject(new Error("JSONの取得に失敗しました."));
            // }
            // if (object.status == 404) {
            //     marietta.WebCADGlobal.showAlert(object.message);
            //     return Promise.resolve();
            // }

            // const selectedMode =  BUILDING_TYPE_HOUSE : BUILDING_TYPE_MANSION;
            // 建築モードの更新
            // marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType = BUILDING_TYPE_HOUSE;
            // if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
            //   marietta.webcad.WebCADGlobal.changeFloor(1);
            // }
  }

  /**
   * WebViewの読み込み実行
   */
  private async readWebView(webViewData) {

    const webcadData = await new WebViewData().execute(webViewData);

    const dataManager = marietta.webcad.util.WebcadJSONParser;
    const d = new Promise((resolve: Function) => {
      dataManager.reproduceWebCAD(JSON.stringify(webcadData), false, true, resolve);
    });
    d.then(() => {
      // UB の高さを部屋の天井高さに（履歴は updateState でリセットされる）
      LiDARUnitBath.fitToCeiling();
      marietta.webcad.WebCADGlobal.webcad2Dmanager.isChanged = false;

      // みんなの間取りの場合は、変更フラグが立つようにする
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.mode === 'template') {
        marietta.webcad.WebCADGlobal.webcad2Dmanager.isChanged = true;
      }

      // 状態更新
      this.updateState();

      //グレードリストを取得
      if( marietta.webcad.WebCADGlobal.webcad2Dmanager.grade ){
        const p = new Promise((resolve: Function) => {
          marietta.webcad.WebCADGlobal.masterManager.getGradeItemMasterData( marietta.webcad.WebCADGlobal.webcad2Dmanager.grade.id, resolve);
        });
        p.then(( list:any[] = null ) => {
          //マスタに更新
          if( list ) marietta.WebCADGlobal.webcad2Dmanager.grade.updateItemList( list );
        });
      }
      marietta.webcad.WebCADGlobal.webcad2Dmanager.enableViewMode();

      // 画像検知データ反映 2024/9
      if (marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_MARK_NO)?.length > 0) {
        const mode3D = new Mode3DTool();
        const markList = marietta.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_MARK_NO) as Mark[];
        const option: optRecognizeMode = {isRecogninzeMode: true, showWizardDialog: true, markList: markList};
        mode3D.setOption(option);
        mode3D.start();
      } else {
        /** 部屋指定ウィザード */
        ThreeView.get().selectWizard();
      }

    }).catch((msg: any) => {
      console.log(msg);
    });
  }

  /**
   * 状態更新
   */
  private updateState() {
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
      marietta.webcad.WebCADGlobal.snapManager.updateSnapElements();
    }
    marietta.webcad.WebCADGlobal.webcad2Dmanager.resetHistory();
    marietta.webcad.WebCADGlobal.scrollerManager.controlLayerEnlargementFit();
    const itemList = marietta.webcad.WebCADGlobal.layerGroup.getAllItems();
    if (itemList.length > 0) {
      marietta.webcad.WebCADGlobal.webcad2Dmanager.updateWallList();
    }
    marietta.webcad.WebCADGlobal.cadAPIManager.MakeRoomWall();
    marietta.webcad.WebCADGlobal.updateMeasureLine(false, false);
    marietta.webcad.WebCADGlobal.quotationItemList.createData();
    // 見積リストの所属部屋名を更新する
    marietta.webcad.WebCADGlobal.quotationItemList.updateRoomTextForAllTables();

    marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
  }
}
